import { axiosInstance } from '../api';

export default function(email) {
    return axiosInstance.post('/api/auth/resetPassword', {
        'username': email,
        'email': email
    });
}